<template>
  <b-modal
    v-model="status"
    :centered="centered"
    hide-header-close
    hide-footer
    hide-header
    no-close-on-backdrop
    body-class="payment-craftgate-modal-body"
    content-class="payment-white-modal-content"
    :size="size"
  >
    <div class="payment-modal">
      <div style="height: 100%; min-height: 500px;">
        <div class="text-right px-1 pt-1">
          <b-button
            variant="outline-dark"
            size="sm"
            :disabled="loading"
            @click="status = false;"
          >
            {{ $t('Close') }}
          </b-button>
        </div>
        <div
          v-if="loading"
          class="loading-spinner"
        >
          <loading-spinner />
        </div>
        <slot>
          <iframe
            id="paymentIframe"
            :src="paymentUrl"
            style="height: 100%; min-height: 500px; background: #fff;"
            width="100%"
          />
        </slot>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BButton, BModal } from 'bootstrap-vue'

export default {
  name: 'PaymentCraftgate',
  components: {
    BButton,
    BModal,
  },
  props: {
    centered: {
      type: Boolean,
      default: true,
    },
    paymentData: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'lg',
    },
  },
  data() {
    return {
      view: true,
    }
  },
  computed: {
    loading() {
      return this.$store.getters['payment/loading']
    },
    status: {
      get() {
        return this.$store.getters['payment/status']
      },
      set(value) {
        this.$store.dispatch('payment/setStatus', value)
      },
    },
    paymentUrl() {
      // Eğer paymentData objesi varsa ve içinde pageUrl varsa, onu döndür
      return this.paymentData && this.paymentData.pageUrl ? this.paymentData.pageUrl : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.loading-spinner {
  position: fixed;
  display: flex;
  top: 50%;
  left: 50%;
  z-index: -1;
}
.payment-modal {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 300px;

  iframe {
    border: none;
  }
}
</style>

<style>
.payment-craftgate-modal-body {
  padding: 0 !important;
  background: #fff !important;
}

/* Ödeme ekranı arkaplanı her temada beyaz */
.payment-white-modal-content,
.payment-white-modal-content .modal-body {
  background: #fff !important;
  background-color: #fff !important;
}
</style>